module.exports = __webpack_public_path__ + "img/filter_list_24px.da9611d3.svg";